import type { AppState } from 'state/state.model';

import type { OrdersBasketWorkspaceMetaState } from './meta.model';

function selectOrdersBasketWorkspaceMetaState(appState: AppState): OrdersBasketWorkspaceMetaState {
  return appState.workspaces.ordersBasket.meta;
}

export function isOrdersBasketWorkspaceTabsFetched(appState: AppState): boolean {
  const state = selectOrdersBasketWorkspaceMetaState(appState);
  return state.workspaceTabsFetched;
}
